/** Public browser preference only. This never stores account or wallet data. */
export const UPDATE_LOG_STORAGE_KEY = 'soonscreener.dismissed-update';
const dismissedInSession = new Set<string>();

export function isUpdateDismissed(id: string): boolean {
  if (dismissedInSession.has(id)) return true;
  try { return window.localStorage.getItem(UPDATE_LOG_STORAGE_KEY) === id; }
  catch { return false; }
}

export function dismissUpdate(id: string): void {
  dismissedInSession.add(id);
  try { window.localStorage.setItem(UPDATE_LOG_STORAGE_KEY, id); }
  catch { /* Optional preference: remember it in this page session instead. */ }
}
